import { createFileRoute } from '@tanstack/react-router';

import { EmployeeDashboardHome, EmployeeDashboardProvider } from '../modules/EmployeeDashboard';
import { PageWrapper } from '../modules/PageWrapper/main';

export const Route = createFileRoute('/home')({
  component: HomeRoute,
  head: () => ({
    meta: [{ title: 'Dashboard' }],
  }),
});

function HomeRoute() {
  return (
    <PageWrapper>
      <EmployeeDashboardProvider>
        <EmployeeDashboardHome />
      </EmployeeDashboardProvider>
    </PageWrapper>
  );
}
